// https://css-tricks.com/svg-path-syntax-illustrated-guide/
import type { Coordinates } from 'modules/people_chart/lib/Coordinates'

type Position = 'relative' | 'absolute'
export const moveCursor = (position: Position, coordinates: Coordinates): string => {
  const [x, y] = coordinates
  const key = position == 'absolute' ? 'M' : 'm'
  return `${key}${x},${y}`
}

export const drawLine = (position: Position, coordinates: Coordinates): string => {
  const [x, y] = coordinates
  const key = position == 'absolute' ? 'L' : 'l'
  return `${key}${x},${y}`
}

export const drawVerticalLine = (position: Position, y: number): string => {
  const key = position == 'absolute' ? 'V' : 'v'
  return `${key}${y}`
}

export const drawHorizontalLine = (position: Position, x: number): string => {
  const key = position == 'absolute' ? 'H' : 'H'
  return `${key}${x}`
}
